module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component component-backoffice-note"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column shrink"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('InterventionRequestButtons', {
    attrs: {
      "item": _vm.item
    }
  })], 1)], 1), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v("IR" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "label"
  }, [_vm._v("Priority")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.priority))])]), _c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Status")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.status))]), _c('div', {
    staticClass: "label"
  }, [_vm._v("Type")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.type))]), (_vm.item.reservation) ? [_c('div', [_c('div', {
    staticClass: "label"
  }, [_vm._v("Reservation  "), _c('router-link', {
    attrs: {
      "to": {
        name: 'reservation',
        params: {
          id: _vm.item.reservation.id
        }
      }
    }
  }, [_c('span', [_vm._v("R" + _vm._s(_vm.item.reservation.id))])])], 1), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.reservation.status))])])] : _vm._e()], 2), _c('div', {
    staticClass: "column"
  }, [(!_vm.item.driver) ? [_c('h5', [_vm._v("Not assigned")])] : _c('BackofficeDriver', {
    attrs: {
      "item": _vm.item.driver,
      "type": "oneLook"
    }
  }), (_vm.item.start) ? [_c('div', {
    staticClass: "label"
  }, [_vm._v("Started at")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.start, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])] : _vm._e(), (_vm.item.end) ? [_c('div', {
    staticClass: "label"
  }, [_vm._v("Completed at")]), (_vm.item.end) ? _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.end, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]) : _vm._e()] : _vm._e()], 2), _c('div', {
    staticClass: "column text-center"
  }, [_c('vehicle', {
    attrs: {
      "item": _vm.item.vehicle,
      "type": "oneLook"
    }
  }), _c('vehicle', {
    attrs: {
      "item": _vm.item.vehicle,
      "type": "maintenance"
    }
  })], 1), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Created")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created_at, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('div', {
    staticClass: "label"
  }, [_vm._v("Start")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.start_at, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('div', {
    staticClass: "label"
  }, [_vm._v("Expiry")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.expiry, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]), _c('div', {
    staticClass: "column shrink text-right"
  }, [(_vm.item.linked_requests.length) ? _c('span', {
    staticClass: "fa fa-2x",
    class: {
      'fa-chevron-up': _vm.showSub, 'fa-chevron-down': !_vm.showSub
    },
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.showSub = !_vm.showSub
      }
    }
  }) : _vm._e()])]), _vm._l((_vm.item.linked_requests), function(request) {
    return (_vm.showSub) ? [_c('hr'), _c('InterventionRequest', {
      attrs: {
        "item": request,
        "type": "detail-listing"
      }
    })] : _vm._e()
  })], 2)]) : _vm._e(), (_vm.$is('detail-listing')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column shrink"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('InterventionRequestButtons', {
    attrs: {
      "item": _vm.item
    }
  })], 1)], 1), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v("IR" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "label"
  }, [_vm._v("Priority")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.priority))])]), _c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Status")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.status))]), _c('div', {
    staticClass: "label"
  }, [_vm._v("Type")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.type))]), (_vm.item.reservation) ? [_c('div', [_c('div', {
    staticClass: "label"
  }, [_vm._v("Reservation  "), _c('router-link', {
    attrs: {
      "to": {
        name: 'reservation',
        params: {
          id: _vm.item.reservation.id
        }
      }
    }
  }, [_c('span', [_vm._v("R" + _vm._s(_vm.item.reservation.id))])])], 1), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.reservation.status))])])] : _vm._e()], 2), _c('div', {
    staticClass: "column"
  }, [(!_vm.item.driver) ? [_c('h5', [_vm._v("Not assigned")])] : _c('BackofficeDriver', {
    attrs: {
      "item": _vm.item.driver,
      "type": "oneLook"
    }
  }), (_vm.item.start) ? [_c('div', {
    staticClass: "label"
  }, [_vm._v("Started at")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.start, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])] : _vm._e(), (_vm.item.end) ? [_c('div', {
    staticClass: "label"
  }, [_vm._v("Completed at")]), (_vm.item.end) ? _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.end, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]) : _vm._e()] : _vm._e()], 2), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Created")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created_at, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('div', {
    staticClass: "label"
  }, [_vm._v("Start")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.start_at, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))]), _c('div', {
    staticClass: "label"
  }, [_vm._v("Expiry")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.expiry, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]), _c('div', {
    staticClass: "column shrink text-right"
  }, [(_vm.item.linked_requests.length) ? _c('span', {
    staticClass: "fa fa-2x",
    class: {
      'fa-chevron-up': _vm.showSub, 'fa-chevron-down': !_vm.showSub
    },
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.showSub = !_vm.showSub
      }
    }
  }) : _vm._e()])]), _vm._l((_vm.item.linked_requests), function(request) {
    return (_vm.showSub) ? [_c('hr'), _c('InterventionRequest', {
      attrs: {
        "item": request,
        "type": "detail-listing"
      }
    })] : _vm._e()
  })], 2)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39fd04de!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/InterventionRequest.vue
// module id = 2413
// module chunks = 1